import React, { StrictMode, useState } from 'react';

import PropTypes from 'prop-types';

import Table from 'components/new_ui/Table';

import useTeams from 'components/Common/Managers/Hooks/useTeams';
import columns from './columns';
import NoData from './NoData';

import Assessment from './Assessment';

import NoIndex from './NoIndex';

export default function Index({ members, onFilteredDataChange }) {
  const [memberAssessment, setMemberAssessment] = useState(null);

  const teams = useTeams();

  const rowActions = [
    {
      type: 'EXPAND',
    },
    {
      title: 'Assessment',
      type: 'CUSTOM',
      iconClass: 'career-pulse-assessment-icon',
      onClick: (row) => {
        setMemberAssessment(row);
      },
      showCondition: (row) => row.attributes.assessments_count > 0,
    },
  ];

  return (
    <StrictMode>
      <h1>Talent Index</h1>

      <section className="pt-2">
        {members && members.filter((item) => item.attributes.coaching_readiness_score).length === 0 ? (
          <NoIndex />
        ) : (
          <Table
            title=" "
            selectableRows={false}
            defaultSortFieldId="talent_index"
            defaultSortAsc={false}
            columns={columns(teams)}
            data={members}
            loading={members == null}
            rowActions={rowActions}
            noData={<NoData />}
            onFilteredDataChange={onFilteredDataChange}
            filterOpen
          />
        )}

      </section>

      {memberAssessment && (
      <Assessment
        member={memberAssessment}
        onClose={() => setMemberAssessment(null)}
      />
      )}

    </StrictMode>
  );
}

Index.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object),
  onFilteredDataChange: PropTypes.func.isRequired,
};

Index.defaultProps = {
  members: null,
};
